import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UpdateUserGuideDto, UserGuideDto } from '../../dto/src/user-app-guide/user-app-guide.dto';

@Injectable({
    providedIn: 'root'
})
export class UserAppGuideService {
    constructor(private http: HttpClient) {}

    findAll(): Observable<UserGuideDto[]> {
        return this.http.get<UserGuideDto[]>('/user-guide?published=false');
    }

    create(data: FormData): Observable<any> {
        return this.http.post<UserGuideDto>('/user-guide', data, {
            reportProgress: true,
            observe: 'events'
        });
    }

    update(id: number, data: FormData): Observable<UserGuideDto> {
        return this.http.put<UserGuideDto>(`/user-guide/${id}`, data);
    }

    updateMany(data: UpdateUserGuideDto[]): Observable<UserGuideDto[]> {
        return this.http.put<UserGuideDto[]>('/user-guide', data);
    }

    delete(id: number): Observable<UserGuideDto> {
        return this.http.delete<UserGuideDto>(`/user-guide/${id}`);
    }
}
